/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * smoothScrollTrigger.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * @name setAnkerLinkMove
 * @description アンカーリンクの設定
 * @param {Object} aTag aタグの要素
 * @param {Function} scroll 指定の位置までスムーススクロールをする関数
 * @param {Function} ankerLink__scroll アンカーリンクをクリックした時にスムーススクロールをする関数
 */
function setAnkerLinkMove() {
  const aTags = document.querySelectorAll('a');
  if (aTags.length === 0) return;

  const scroll = (movePos) => window.scrollTo({ top: movePos, behavior: "smooth", });

  const ankerLink__scroll = (e) => {
    let href = e.currentTarget.getAttribute("href");
    let target = document.getElementById(href.split("#")[1]);
    if (!target) return;
    e.preventDefault();
    history.pushState(null, null, href);
    let position = target.getBoundingClientRect().top + window.pageYOffset;
    scroll(position);
  };

  aTags.forEach((el) => el.addEventListener("click", (e) => ankerLink__scroll(e)));
}

export {
  setAnkerLinkMove
};